import React, { useState, useRef, useEffect } from 'react';
import { HiChevronDown, HiMenuAlt3 } from "react-icons/hi";
import { Link } from 'react-router-dom';
import logo from '../../images/logo2.png';
import './nav.css';
import Steps from '../../pages/Steps/Steps.jsx';
import { useNavigate } from 'react-router-dom';

const Navigation = () => {
    const [aboutDropdown, setAboutDropdown] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isStepsPopupVisible, setIsStepsPopupVisible] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const toggleAboutDropdown = () => {
        setAboutDropdown(!aboutDropdown);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleStepsPopup = () => {
        setIsStepsPopupVisible(!isStepsPopupVisible);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setAboutDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <header className="header">
            <div className="logo">
                <div>
                    <Link to="/"><img src={logo} alt="Logo" /></Link>
                </div>
            </div>

            <nav>
                <div className="hamburger" onClick={toggleMobileMenu}>
                    <HiMenuAlt3 size={30} />
                </div>
                <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                    <li><Link to="/">HOME</Link></li>
                    <li onClick={toggleStepsPopup} className='stepsbutton'>STEPS</li>
                    <li
                        className="dropdown"
                        ref={dropdownRef}
                        onClick={toggleAboutDropdown}
                        onMouseEnter={() => setAboutDropdown(true)}
                        onMouseLeave={() => setAboutDropdown(false)}
                    >
                        <Link to="/services">
                            SERVICES
                        </Link>
                        {aboutDropdown && (
                            <div className="dropdown-menu">
                                <div className="dropdown-column">
                                    <ul>
                                        <li><Link to="/services/therapy1">Pelvic Floor Therapy</Link></li>
                                        <li><Link to="/services/therapy2">Sports Rehabilitation</Link></li>
                                        <li><Link to="/services/therapy3">Manual Therapy</Link></li>
                                        <li><Link to="/services/therapy4">Post-Surgical Rehabilitation</Link></li>
                                        <li><Link to="/services/therapy5">Chronic Pain Management</Link></li>
                                        <li><Link to="/services/therapy6">Dry Needling</Link></li>
                                        <li><Link to="/services/therapy7">Cupping Therapy</Link></li>
                                        <li><Link to="/services/therapy8">TENS Machine</Link></li>
                                    </ul>
                                </div>
                                <div className="dropdown-column">
                                    <ul>
                                        <li><Link to="/services/therapy12">Electrical Stimulation Therapy (E-Stim)</Link></li>
                                        <li><Link to="/services/therapy13">Kinesiology Taping</Link></li>
                                        <li><Link to="/services/therapy14">Heat and Cold Therapy (Cryotherapy and Thermotherapy)</Link></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </li>
                    <li><Link to="/clinic">THERAPIST</Link></li>
                    <li><Link to="/location">LOCATION</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                    <li className="button-container">
                        <a href="https://mantraflexinc.janeapp.com/" rel="noopener noreferrer" className="book-button">Book Now</a>
                    </li>
                </ul>
            </nav>

            {isStepsPopupVisible && <Steps toggleStepsPopup={toggleStepsPopup} isStepsPopupVisible={isStepsPopupVisible} />}
        </header>
    );
};

export default Navigation;
